module.exports = __webpack_public_path__ + "static/media/news-image-02.22463017.jpg";